var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", [
      _c("a", {
        staticClass: "btn-back",
        attrs: { href: "javascript:history.go(-1)" },
      }),
      _vm._v(" "),
      _c("h2", [_vm._v("热搜词")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }